module.exports = __webpack_public_path__ + "static/media/ts1cr44.18f5a8a2.png";